import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
export var StyledTableCell = styled(TableCell)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(tableCellClasses.head)] = {
            backgroundColor: "#034EA2",
            color: theme.palette.common.white,
            padding: 10,
            textAlign: "center",
            fontWeight: "bold",
        },
        _b["&.".concat(tableCellClasses.body)] = {
            fontSize: 14,
        },
        _b);
});
